module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-loader",
    style: ({
      'background-color': _vm.bgColor
    })
  }, [(_vm.loaderType === 'fullBG') ? _c('div', {
    staticClass: "_fullBG"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.loaderType === 'linear') ? _c('div', {
    staticClass: "_linear"
  }, [_c('v-progress-linear', {
    staticClass: "primary--text app-loader_linear",
    attrs: {
      "value": _vm.loadValue,
      "height": "2"
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-def center"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ca62905","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appLoader.vue
// module id = 1665
// module chunks = 180